import { z } from "zod";

export const giftIdentificationSchema = z.object({
  giftCode: z.string(),
  last_name: z.string().min(1),
  first_name: z.string().min(1),
  email: z.string().email(),
  phone: z.string().min(1),
});

export type GiftIdentificationFormValues = z.infer<typeof giftIdentificationSchema>;
